module.exports = "/assets/5ce34c264dd19c92e1793d2a1930fb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7I.png
// module id = 1112
// module chunks = 0